import {Divider, Space, Stack, TextInput} from '@mantine/core';
import { i18n } from '@lingui/core';
import { useContext } from 'react';
import { DatePicker } from '@mantine/dates';
import { ContractContext } from '../../../Service/Context/ContractContextV2';
import { ThemeText } from '../../../Atoms/ThemeText';
import {RichInput} from "../../../Organismns/tiptap/TiptapEditorInput";
import {TiptapS} from "../../../Service/TiptapS";

const ContractGeneralSection = () => {
  const { contract, savePatch } = useContext(ContractContext);
  const { date, number, label, title } = contract ?? {};

  if (!contract) {
    return null;
  }

  return (
    <>
      <ThemeText weight="bolder" size="lg" mt="sm" mb="md">
        Allgemein
      </ThemeText>
      <Stack sx={{ maxWidth: 600 }}>
        <TextInput defaultValue={number} label="Nummer" onBlur={(e) => savePatch({ number: e.currentTarget.value })} />
        <DatePicker
          clearable={false}
          label={i18n._('contract.date')}
          value={date ? new Date(date) : null}
          placeholder="-"
          onChange={(val) => savePatch({ date: val })}
        />
        <TextInput
          defaultValue={label}
          label="Name (für Kunden sichtbar)"
          onBlur={(e) => savePatch({ label: e.currentTarget.value })}
        />
        <Space h="xs" />

        <RichInput
          label="Titel"
          value={title ?? ''}
          patchField={async (htmlString) => {
            const res = await savePatch({ title: htmlString });
            return res !== null;
          }}
          styles={TiptapS.TextInputStyles}
        />

      </Stack>
      <Divider my={30} />
    </>
  );
};

export default ContractGeneralSection;
